'use strict';

export class AccessionBarcodeDialogModel {
  constructor(data) {
    this.data = angular.copy(data);
  }

  init(modal, scope) {
    this.scope = scope;
    this.modalInstance = modal;
  }

  close() {
    this.cancelled = true;
    this.modalInstance.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/accessionBarcode.js